import React, { useMemo, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import lottoLogo from '../assets/images/lottologo.jpg';
import fairWaysLogo from '../assets/images/fairways.jpeg';
import template4Logo from '../assets/images/template4logo.jpg';
dayjs.extend(customParseFormat);

export default function TicketTemplate1({
  transaction,
  displayName,
  userName,
}) {
  const bets = useMemo(() => {
    const sortedBets = [...transaction.bets].sort((a, b) => {
      if (a.drawTime !== b.drawTime)
        return a.drawTime.localeCompare(b.drawTime);
      const gameA = a.GameSetting?.name || a.gameName || '';
      const gameB = b.GameSetting?.name || b.gameName || '';
      return gameA.localeCompare(gameB);
    });
    return sortedBets;
  }, [transaction]);

  const drawId = dayjs(transaction.drawDate)
    .diff(dayjs('2025-04-12'), 'day')
    .toString()
    .padStart(4, '0');

  return (
    <div className='grid max-h-0 overflow-hidden'>
      <div
        id='print-ticket'
        className='w-[230px] text-[13.5px] flex flex-col gap-4 bg-white font-bitMatrix antialiased'
      >
        <div className='flex flex-col'>
          <div className='flex flex-col justify-between'>
            <div className='leading-tight'>
              <div className='flex justify-center items-center gap-1 w-full mb-1'>
                <img src={lottoLogo} className='h-[60px]' />
                <img src={fairWaysLogo} className='h-[70px]' />
                <img src={template4Logo} className=' h-[60px]' />
              </div>
              <span className='w-full h-[1px] border-t border-dashed border-black my-2 block'></span>
              <div>Fair Ways Management Gaming Corp</div>
              <span className='w-full h-[1px] border-t border-dashed border-black my-2 block'></span>

              <div className='flex flex-col text-left'>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Ref No :</span>
                  {drawId +
                    '-' +
                    dayjs(transaction.bets[0].createdAt).format('YYMMDD') +
                    new Date().getTime().toString().slice(-6)}
                </div>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Game :</span>
                  {'3D'}
                </div>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Agent :</span>
                  {displayName}
                </div>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Draw :</span>
                  {dayjs(transaction.bets[0].createdAt).format('MMM DD, YYYY ')}
                  {dayjs(transaction.drawTime, 'HH:mm').format('hA')}
                </div>

                <div className='grid grid-cols-3 '>
                  <div></div>
                  <div>Nos</div>
                  <div>Amount</div>
                </div>
                {bets.map((bet, index) => (
                  <div key={index} className='grid grid-cols-3  '>
                    <div className='text-center'>
                      {bet.bettingOption === 'ramble' ? 'R' : 'T'}
                    </div>
                    <div>{bet.combination}</div>
                    <div>{bet.amount}</div>
                  </div>
                ))}

                <div className='flex mt-3'>
                  <span className='w-[65px] text-right mr-1'>Total :</span>Php{' '}
                  {transaction.totalAmount}
                </div>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Bets :</span>
                  {bets.length} bets
                </div>
              </div>
            </div>
            {/* QR Code */}
            <div className='flex mb-3'>
              <span className='w-[65px] text-right mr-1'>Printed :</span>
              {dayjs(transaction.bets[0].createdAt).format(
                'MMM DD, YYYY HH:mm:ss'
              )}
            </div>
            <span className='text-center'>TRIPLE NUMBER WIN 300</span>
            <div className='flex justify-center my-2'>
              <QRCodeSVG value={transaction.id} width={80} height={80} />
            </div>
          </div>
        </div>
        <div className='h-4'></div>
      </div>
    </div>
  );
}
